import "./textImageImage.scss";
import dynamic from 'next/dynamic';
const Image = dynamic(() => import("../elements/image"), {ssr: false, loading: () => null });

export default ({pictureOne, pictureTwo, copy, centerCopy = true}) => (
  <section>
    <div className="article-textImageImage">
      <div className="col">
        <div className={`copy ${centerCopy === true && "center"}`}>{copy}</div>
      </div>
      <div className="col">
        <div className="picture">
          <Image className="image" image={pictureOne.image} />
          <div className="caption">{pictureOne.caption}</div>
        </div>
      </div>
      <div className="col">
        <div className="picture">
          <Image className="image" image={pictureTwo.image} />
          <div className="caption">{pictureTwo.caption}</div>
        </div>
      </div>
    </div>
  </section>
);
